import React from "react"
import styled, { keyframes } from "styled-components"
import { DateTime } from "luxon"

import TimeZones from "./fetch-time"

const TickTock = keyframes`
  0% {
    opacity: 1;
  }
  49% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
`

const Tick = styled.span`
  animation: ${TickTock} 2s infinite linear;
`

export const BerlinTime = () => {
  return (
    <React.Fragment>
      {TimeZones().berlin.hours}
      <Tick>:</Tick>
      {/* {TimeZones().berlin.minutes} (+1 GMT) */}
      {/* {TimeZones().berlin.minutes} (+2 GMT) */}
      {TimeZones().berlin.minutes} (+
      {DateTime.now().setZone("Europe/Berlin").offset / 60} GMT)
    </React.Fragment>
  )
}

export const LaTime = () => {
  return (
    <React.Fragment>
      {TimeZones().la.hours}
      <Tick>:</Tick>
      {/* {TimeZones().la.minutes} (-8 GMT) */}
      {/* {TimeZones().la.minutes} (-7 GMT) */}
      {TimeZones().la.minutes} (
      {DateTime.now().setZone("America/Los_Angeles").offset / 60} GMT)
    </React.Fragment>
  )
}
